import { companydropdown } from "../blocks/companies-accordion";
import { hidedropdown } from "../blocks/companies-accordion";

export let companiesFilters = function () {

  const topLevelFilters = document.querySelectorAll('button.accordion');
  const bottomLevelPanels = document.querySelectorAll('.bottom-level .panel');

  topLevelFilters.forEach(function(topLevel) {

    topLevel.addEventListener('click', function() {
      let clickedTopButton = topLevel;
      if(topLevel.classList.contains('practice')) {
        bottomLevelPanels.forEach(function(panel) {
          if(panel.classList.contains('practice') && clickedTopButton.classList.contains('practice')) {
            panel.classList.toggle('open');
          } 
        })
      };

      if(topLevel.classList.contains('partners') && clickedTopButton.classList.contains('partners')) {
        bottomLevelPanels.forEach(function(panel) {
          if(panel.classList.contains('partners')) {
            panel.classList.toggle('open');
          } 
        })
      };

      if(topLevel.classList.contains('authors') && clickedTopButton.classList.contains('authors')) {
        bottomLevelPanels.forEach(function(panel) {
          if(panel.classList.contains('authors')) {
            panel.classList.toggle('open');
          } 
        })
      };

      if(topLevel.classList.contains('categories') && clickedTopButton.classList.contains('categories')) {
        bottomLevelPanels.forEach(function(panel) {
          if(panel.classList.contains('categories')) {
            panel.classList.toggle('open');
          } 
        })
      };
    });
  });
}


let displayPosts = function(data) {
  $("#companies_table tbody").html(data.content);
  dayshift_loadmore_params.current_page = 1;
  dayshift_loadmore_params.max_page = data.max_page;
  dayshift_loadmore_params.query_vars = data.query_vars;

  if(dayshift_loadmore_params.current_page === dayshift_loadmore_params.max_page) {
    $('button#loadmore').addClass('hide');
    $('#companies_table').css("margin-bottom", "100px");
  } else {
    $('button#loadmore').removeClass('hide');
    $('#companies_table').css("margin-bottom", "0px");
  }

  hidedropdown();
}

$("#all-companies-filters .top-level button").on("click", function(e) {
  e.preventDefault();
})

  $(".all-companies-filters input").on("click", function(e) {
    let term_name = $(this).data('term-name');
    let filter_id = `${this.name}-${this.value}`;
    let filter_value = $(this).attr("id");
    let input_match = $(".inserted-filter").data("input-match");

      if($(this).prop('checked') && $(this).attr("id") != 'A-Z') {
        $(".company-archive--filter-bar").addClass('active');
        $(".company-filter-bar--filters").prepend(`<span class="inserted-filter" data-input-match="${filter_value}" id="${filter_id}">${term_name}<svg xmlns="http://www.w3.org/2000/svg" width="10.745" height="11.083" viewBox="0 0 10.745 11.083"><g id="Group_3386" data-name="Group 3386" transform="translate(-532.274 -524.585)"><path id="Path_1162" data-name="Path 1162" d="M1040.209,54l4.6,4.846L1049.5,54" transform="translate(1582.502 588.973) rotate(180)" fill="none" stroke="#000" stroke-width="2"/><path id="Path_1163" data-name="Path 1163" d="M1040.209,54l4.6,4.846L1049.5,54" transform="translate(-507.209 471.281)" fill="none" stroke="#000" stroke-width="2"/></g></svg></span>`);
      } else if($(this).prop('checked') && $(this).attr("id") == "A-Z") {
          $('#A-Z').prop('checked', true);
      } else if ($(this).prop('checked', false)){
          $(`#${filter_id}`).remove();
      } 

      $("#all-companies-filters").submit();
  });

  $('.company-archive--filter-bar').on('click', '.inserted-filter' , function() {
    let input_match = $(this).data("input-match");
    $(this).remove();
    $('#all-companies-filters').find('#'+input_match).prop('checked', false).attr("checked", false);

    $('#all-companies-filters').submit();
  });

  let clear_filters = function() {
      $('.all-companies-filters').find('input:checked').prop('checked', false).attr("checked", false);
      $('#all-companies-filters').removeClass('active');
      $('.accordion').removeClass('open');
      $('.panel').removeClass('open');
      $('.top-level').removeClass('open');
      $('.company-archive--filter-bar').removeClass('active');
      $('.company-archive--filter-bar .inserted-filter').each(function() {
        let input_match = $(this).data("input-match");
        $(this).remove();
        $('#all-companies-filters').find('#'+input_match).prop('checked', false).attr("checked", false);
        $('#all-companies-filters').find('#A-Z').prop('checked', true).attr('checked',true);
      });

    $('#all-companies-filters').submit();
  }

  $('.archive--clear').on('click', function() {
    clear_filters();
    $('body').removeClass('filter-open');
    $('body').removeClass('fixed');
    $('.not-popup-filters').removeClass('hide');
  });

  $("#all-companies-filters").submit(function (e) {
        e.preventDefault();
        filterAjax($(this));
  });

    // Get Practice from URL
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const practice = urlParams.get('practice');
    let preFilter = document.getElementById(practice);
    let preFilterLabel = document.getElementById(practice + "_label");
    setTimeout(function(){$(preFilter).trigger("click");console.log(practice);}, 500);

let filterAjax = function(filters) {
  let allFilters = filters.serializeArray();
  let practicesAndPartners = [];
  let sort = [];

  allFilters.forEach(function(filter) {
    if(filter.name === 'sort') {
      sort.push(filter);
    } else {
      practicesAndPartners.push(filter);
    }
  })

  let number_of_active_filters = practicesAndPartners.length;

  $('#filter-bar--mobile-button span.count').text("(" + number_of_active_filters + ")");
  $('#filter-bar--mobile-button--popup-filters span.count').text("(" + number_of_active_filters + ")");


  if(number_of_active_filters == 0) {
    $('.company-archive--filter-bar').removeClass('active');
    $('#filter-bar--mobile-button span.count').text("(" + number_of_active_filters + ")");
  }

  if(number_of_active_filters == 0) {
    $('#filter-bar--mobile-button span.count').text("");
    $('#filter-bar--mobile-button').css('justify-content', 'center')
    $('#filter-bar--mobile-button--popup-filters span.count').text("");
    $('#filter-bar--mobile-button--popup-filters').css('justify-content', 'center')
  } else if(number_of_active_filters >= 1) {
    $('#filter-bar--mobile-button').css('justify-content', 'space-between');
    $('#filter-bar--mobile-button--popup-filters').css('justify-content', 'space-between');
  }

  $.ajax({
    url: dayshift_loadmore_params.ajaxurl,
    data: {
      action: "articles_filter",
      query: dayshift_loadmore_params.posts,
      params: practicesAndPartners,
      sort_inputs: sort,
      current_page: dayshift_loadmore_params.current_page
    },
    dataType: "json",
    type: "POST",
    beforeSend: function () {
    },
    error: function (result) {
      console.warn("error on filter", result);
    },
    success: function (result) {
      displayPosts(result);
      companydropdown();
    }
  })
}